import { render, staticRenderFns } from "./YearTab.vue?vue&type=template&id=4d27b1b2"
import script from "./YearTab.vue?vue&type=script&lang=js"
export * from "./YearTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports